import { useUserManagement } from "@/pages/user/hooks/useUserManagement";
import { UserDialogs } from "@/pages/user/components/UserDialogs";
import { UserTabs } from "@/pages/user/components/UserTabs";

const UserManagementPage = () => {
  const {
    isProfileDialogOpen,
    isEditDialogOpen,
    isChangeDeptDialogOpen,
    isChangeStatusDialogOpen,
    isPasswordResetDialogOpen,
    selectedUser,
    viewUserProfile,
    handleEditUser,
    saveEditedUser,
    saveDepartmentChange,
    saveStatusChange,
    onResetPassword,
    onResetPasswordInternal,
    handleProfileDialogClose,
    handleEditDialogClose,
    handleChangeDeptDialogClose,
    handleChangeStatusDialogClose,
    handlePasswordResetDialogClose,
  } = useUserManagement();

  return (
    <>
      <UserTabs
        onViewProfile={viewUserProfile}
        onEditUser={handleEditUser}
        onResetPassword={onResetPassword}
      />
      
      <UserDialogs
        isProfileDialogOpen={isProfileDialogOpen}
        isEditDialogOpen={isEditDialogOpen}
        isChangeDeptDialogOpen={isChangeDeptDialogOpen}
        isChangeStatusDialogOpen={isChangeStatusDialogOpen}
        isPasswordResetDialogOpen={isPasswordResetDialogOpen}
        selectedUser={selectedUser}
        handleProfileDialogClose={handleProfileDialogClose}
        handleEditDialogClose={handleEditDialogClose}
        handleChangeDeptDialogClose={handleChangeDeptDialogClose}
        handleChangeStatusDialogClose={handleChangeStatusDialogClose}
        handlePasswordResetDialogClose={handlePasswordResetDialogClose}
        saveEditedUser={saveEditedUser}
        saveDepartmentChange={saveDepartmentChange}
        saveStatusChange={saveStatusChange}
        onResetPasswordInternal={onResetPasswordInternal}
      />
    </>
  );
};

export default UserManagementPage; 